import { IonContent, IonInput, IonPage, IonText,IonSpinner } from "@ionic/react"
import moment from "moment"
import { useEffect, useState, useMemo } from "react"
import { Modal } from "react-bootstrap"
import { useHistory } from "react-router"
import DataTable from "react-data-table-component"
import service from "../../../Service/service"
import Head from "../../Header"
import Sidebar from "../../Sidebar"
import swal from 'sweetalert';
import { Console } from "console"

const HRClient: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);

    const [data, setData]: any = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [modalopen, setModalopen] = useState(false);
    const [modalopen1, setModalopen1] = useState(false);

    const [id, setId] = useState("");

    /*............ Create ............ */
    const [ClientName, setClientName] = useState("");
    const [contactName, setContactName] = useState("");
    const [contactNo, setContactNo] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const [GST, setGST] = useState("");
    const [companyAddress, setCompanyAddress] = useState("");
    const [activeProjects, setActiveProjects] = useState('');
    const [holdProjects, setholdProjects] = useState('');
    const [closeProjects, setcloseProjects] = useState('');
    const [crtBy] = useState(localStorage.getItem('SignupEmpId'));
    const [updBy] = useState(localStorage.getItem('SignupEmpId'));
    const [loading,setloading]=useState(false)
    var expr = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/;
    var regName = /[a-zA-Z]{3,}/;
    var ContactregName = /[a-zA-Z]{3,}/;
    const mailPat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    /*...........View & Update............ */

    const [cname, setCname] = useState("");
    const [contactname, setContactname] = useState("");
    const [contactno, setContactno] = useState("");
    const [createdby, setCreatedby] = useState("");
    const [contactemail, setContactemail] = useState("");
    const [gst, setGst] = useState("");
    const [address, setAddress] = useState("");
    const [Resources, setResources] = useState([]);
    const [Projects, setProjects] = useState([]);

    /*..............Getall Client Datatable.............*/

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            width: "70px",
        },
        {
            name: "Client Name",
            selector: (itm: any) => itm.clientName,
            sortable: true,
            width:"250px"
        },
        {
            name: "Created Date",
            sortable: true,
            cell: (itm: any) => {
                var crDate = moment(itm.createdDate).format("DD-MM-YYYY")
                return (
                    <>
                        <IonText>{crDate}</IonText>
                    </>
                )
            }
        },
        {
            name: "Created By",
            selector: (itm: any) => itm.createdBy,
            sortable: true,
        },
        // {
        //     name: "No. Of Projects",
        //     selector: (itm: any) => itm.noOfProjects,
        //     sortable: true,
        // },
        {
            name: "Active Project",
            selector: (itm: any) => itm.activeProject,
            sortable: true,
        },
        {
            name: "Hold Project",
            selector: (itm: any) => itm.holdProject,
            sortable: true,
        },
        {
            name: "Close Project",
            selector: (itm: any) => itm.closeProject,
            sortable: true,
        },
        {
            name: "Action",
            sortable: false,
            width: "100px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                        <IonText style={{ color: "coral", cursor: 'pointer' }} onClick={() => openmodal(itm.id)} >View</IonText>
                    </div>
                </>
            )
        }
    ];
    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "500",
                fontSize: "15px",
            },
        },
        cells: {
            style: {
                fontSize: "15px"
            }
        }
    };

    /*...............Search filter...............*/

    const tabledata = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);

    //...................View Client..................//

    useEffect(() => {
        View();
    }, []);

    const View = () => {
        setloading(true);
        service.ViewClientList()
            .then((response) => {
                console.log(response.data);
                if (response.data.Status === "400") {
                    setData([]);
                } else {
                    setData(response.data.Data);
                }
            })
            .catch((error) => {
                swal(error);
            })
            .finally(() => {
               
                setTimeout(() => {
                    setloading(false); 
                }, 500);
            });
    };

    const openmodal = (id: any) => {
        setId(id)
        setModalopen(true);
        // View();
        service.ViewClientById(id)
            .then((response) => {
                if (response.status == 200) {
                    console.log(response.data);
                    if (response.data.data.clientName === null || response.data.data.clientName === "") {
                        setCname("")
                    }
                    else {
                        setCname(response.data.data.clientName)
                    }
                    if (response.data.data.contactName === null || response.data.data.contactName === "") {
                        setContactname("")
                    }
                    else {
                        setContactname(response.data.data.contactName)
                    }
                    if (response.data.data.contactEmail === null || response.data.data.contactEmail === "") {
                        setContactemail("")
                    }
                    else {
                        setContactemail(response.data.data.contactEmail)
                    }
                    if (response.data.data.contactNo === null || response.data.data.contactNo === "") {
                        setContactno("")
                    }
                    else {
                        setContactno(response.data.data.contactNo)
                    }
                    if (response.data.data.gst === null || response.data.data.gst === "") {
                        setGst("")
                    }
                    else {
                        setGst(response.data.data.gst)
                    }
                    if (response.data.data.createdBy === null || response.data.data.createdBy === "") {
                        setCreatedby("")
                    }
                    else {
                        setCreatedby(response.data.data.createdBy)
                    }
                    if (response.data.data.company_Address === null || response.data.data.company_Address === "") {
                        setAddress("")
                    }
                    else {
                        setAddress(response.data.data.company_Address)
                    }
                    if (response.data.Resources === null || response.data.Resources === "") {
                        setResources([])
                    }
                    else {
                        setResources(response.data.Resources)
                    }
                    if (response.data.projects === null || response.data.projects === "") {
                        setProjects([])
                    }
                    else {
                        setProjects(response.data.projects)
                    }
                    // ------------------Active Project ----------------
                    if (response.data.data.activeProject === null || response.data.activeProject === "") {
                        setActiveProjects('')
                    }
                    else {
                        setActiveProjects(response.data.data.activeProject)
                    }
                    if (response.data.data.closeProject === null || response.data.data.closeProject === "") {
                        setcloseProjects('')
                    }
                    else {
                        setcloseProjects(response.data.data.closeProject)
                    }
                    if (response.data.data.holdProject === null || response.data.data.holdProject === "") {
                        setholdProjects('')
                    }
                    else {
                        setholdProjects(response.data.data.holdProject)
                    }

                }

            })

    }

    const openmodal1 = () => {
        setModalopen1(true);
    }

    const closemodal = () => {
        setModalopen(false);
    }

    const closemodal1 = () => {
        setModalopen1(false);
        setClientName("");
        setContactName("");
        setContactNo("");
        setContactEmail("");
        setGST("");
        setCompanyAddress("");
    }

    //................Create Client.................//

    const Create = () => {
        if (ClientName.length == 0) {
            swal("", "Please Enter Client Name", "info");
            return;
        }
        else if (!regName.test(ClientName)) {
            swal("", "Invalid Name Given", "info");
            return;
        }
        else if (contactName.length == 0) {
            swal("", "Please Enter Contact Number", "info");
            return;
        }
        else if (!ContactregName.test(contactName)) {
            swal("", "Invalid  Contact Name ", "info");
            return;
        }
        else if (contactNo.length == 0) {
            swal("", "Please Enter Contact No", "info");
            return;
        }
        else if (contactNo.length !== 10) {
            swal("", "Please Enter Valid Number", "info");
        }
        else if (contactEmail.length == 0) {
            swal("", "Please Enter Contact Email", "info");
            return;
        }
        else if (mailPat.test(contactEmail) === false) {
            swal("", "Please enter Vaild Email Id", "info");
        }
        else {
            service.CreateClient(ClientName, contactName, contactNo, contactEmail, GST, companyAddress, crtBy)
                .then((response) => {
                    console.log(response);
                    if (response.status == 200) {
                        swal("", "Created Successfully", "success");
                        window.location.reload();
                    }
                    else {
                        swal("", "Not Created", "error");
                    }
                })
        }
    }

    //....................Update Client.....................//

    const Update = () => {
        if (cname.length == 0) {
            swal("", "Please Enter Client Name", "info");
            return;
        }
        else if (!regName.test(cname)) {
            swal("", "Invalid Name Given", "info");
            return;
        }
        else if (contactname.length == 0) {
            swal("", "Please Enter Contact Number", "info");
            return;
        }
        else if (!ContactregName.test(contactname)) {
            swal("", "Invalid  Contact Name ", "info");
            return;
        }
        else if (contactno.length == 0) {
            swal("", "Please Enter Contact No", "info");
            return;
        }
        else if (contactemail.length == 0) {
            swal("", "Please Enter Contact Email", "info");
            return;
        }
        else if (mailPat.test(contactemail) === false) {
            swal("", "Please enter Vaild Email Id", "info");
        }
        else {
            service.UpdateClient(id, cname, contactname, contactno, contactemail, gst, address, updBy)
                .then((response) => {
                    console.log(response);
                    if (response.status == 200) {
                        console.log(response.data);
                        swal("", "Updated Successfully", "success");
                    }
                    else {
                        swal("", "Not Updated", "error");
                    }
                })
        }
    }
    const back = () => {
        history.goBack();
    }
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Client </h3>
                                </div>
                                <div className="col-auto float-end ml-auto">
                                    <a onClick={() => openmodal1()} className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave"><i className="fa fa-plus" /> Create Client </a>
                                </div>
                            </div>
                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={tabledata}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    dialogClassName="my-modal modal-dialog-centered"
                    show={modalopen}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">View Client</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {/* <form> */}
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-lg-4 col-md-4">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Client Name <span className="text-danger">*</span></label>
                                        <div>
                                            <IonInput value={cname} onIonChange={(e: any) => setCname(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Contact Name <span className="text-danger">*</span></label>
                                        <div>
                                            <IonInput value={contactname} onIonChange={(e: any) => setContactname(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Contact No <span className="text-danger">*</span></label>
                                        <div>
                                            <IonInput value={contactno} onIonChange={(e: any) => setContactno(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Contact Email <span className="text-danger">*</span></label>
                                        <div>
                                            <IonInput value={contactemail} onIonChange={(e: any) => setContactemail(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>GST </label>
                                        <div>
                                            <IonInput value={gst} onIonChange={(e: any) => setGst(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Company Address </label>
                                        <div>
                                            <IonInput value={address} onIonChange={(e: any) => setAddress(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Active Project</label>
                                        <div>
                                            <IonInput value={activeProjects} readonly className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Hold Project </label>
                                        <div>
                                            <IonInput value={holdProjects} readonly className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Close Project </label>
                                        <div>
                                            <IonInput value={closeProjects} readonly className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Active Project <span className="text-danger">*</span></label>
                                        <div>
                                            <IonInput value={contactemail} onIonChange={(e: any) => setContactemail(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Hold Project </label>
                                        <div>
                                            <IonInput value={gst} onIonChange={(e: any) => setGst(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Close Project</label>
                                        <div>
                                            <IonInput value={address} onIonChange={(e: any) => setAddress(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                </div> */}
                                <div className="submit-section">
                                    <button type="button" className="btn-primary submit-btn" onClick={() => Update()}>Update</button>
                                </div>

                                <div className="row" style={{ marginTop: "2%" }}>
                                    <div className="col-lg-6 col-12">
                                        <div className="form-group" >
                                            <label style={{ fontWeight: "bold" }}>Assigned Resources</label>
                                            <div className="form-control datetimepicker" style={{ height: "150px", overflowY: "scroll", backgroundColor: "#DCDCDC" }}>
                                                {Resources.length > 0 && Resources.map((itm: any) => (
                                                    <li>{itm}</li>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-12">
                                        <div className="form-group" >
                                            <label style={{ fontWeight: "bold" }}>Assigned Projects</label>
                                            <div className="form-control datetimepicker" style={{ height: "150px", overflowY: "scroll", backgroundColor: "#DCDCDC" }}>
                                                {Projects.length > 0 && Projects.map((itm: any) => (
                                                    <li>{itm}</li>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        {/* </form> */}
                    </div>
                </Modal>
                <Modal
                    // id="logouts-modal"
                    dialogClassName="modal-dialog modal-lg"
                    show={modalopen1}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">Create Client</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal1()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Client Name <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={ClientName} onIonChange={(e: any) => setClientName(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Contact Name <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={contactName} onIonChange={(e: any) => setContactName(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Contact No <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={contactNo} onIonChange={(e: any) => setContactNo(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Contact Email <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={contactEmail} onIonChange={(e: any) => setContactEmail(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>GST </label>
                                <div>
                                    <IonInput value={GST} onIonChange={(e: any) => setGST(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Company Address </label>
                                <div>
                                    <IonInput value={companyAddress} onIonChange={(e: any) => setCompanyAddress(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="button" className="btn-primary submit-btn" onClick={() => Create()}>Update</button>
                            </div>
                        </form>
                    </div>
                </Modal>
            </IonContent>
        </IonPage>
    )
}

export default HRClient

























































